import { Button, Typography } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import type { TemplateWriteAccess } from "../hooks/useVersionDraft"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { PostBotPageLayout } from "../components/common/postBotPageLayout"
import { TemplatesTable } from "../components/templates/templatesTable"
import {
  readTemplateReturnContext,
  templatesPath,
} from "../components/templates/templateNavigation"

export default function TemplatesPage(props: TemplateWriteAccess) {
  const { state } = useLocation()
  const returnContext = readTemplateReturnContext(state)
  return (
    <PostBotPageLayout>
      <PostBotNavigation />
      <Typography variant="h5">Шаблоны</Typography>
      {!props.readOnly && props.canWrite !== false && (
        <Button
          component={Link}
          to={`${templatesPath}/new`}
          state={returnContext}
          variant="contained"
          sx={{ alignSelf: "flex-start" }}
        >
          Создать шаблон
        </Button>
      )}
      <TemplatesTable returnContext={returnContext} />
    </PostBotPageLayout>
  )
}
